export default __webpack_public_path__ + "static/media/user.f2b49fcc.svg";